import { EnvironmentFilled, GlobalOutlined } from "@ant-design/icons";
import React, { useCallback, useMemo } from "react";
import { ReactComponent as FacebookSvg } from "../../../../app/assets/svg/facebook.svg";
import { ReactComponent as InstagramSvg } from "../../../../app/assets/svg/instagram.svg";
import { ReactComponent as LinkedinSvg } from "../../../../app/assets/svg/linkedin.svg";
import { ReactComponent as MailSvg } from "../../../../app/assets/svg/mail.svg";
import { ReactComponent as PhoneSvg } from "../../../../app/assets/svg/phone.svg";
import { ReactComponent as VkSvg } from "../../../../app/assets/svg/vk.svg";
import { ReactComponent as YoutubeSvg } from "../../../../app/assets/svg/youtube.svg";
import { ReactComponent as TelegramSvg } from "../../../../app/assets/svg/telegram.svg";
import { ReactComponent as MaxSvg } from "../../../../app/assets/svg/max.svg";
import { Company, Social } from "../../../../app/model/company";
import { ContactItem, ContactsContainer } from "./styles";
import i18n from "../../../../i18n";

interface CompanyContactsProps {
  company: Company;
}

export default function CompanyContacts({ company }: CompanyContactsProps) {
  const icons = useMemo((): { [key in keyof Partial<Company>]: React.ReactNode } => ({
    phone: <PhoneSvg />,
    country: <EnvironmentFilled />,
    email: <MailSvg />,
    site: <GlobalOutlined />
  }), [])

  const socialIcons = useMemo((): { [key in Social]: React.ReactNode } => ({
    facebook: <FacebookSvg />,
    instagram: <InstagramSvg />,
    linkedin: <LinkedinSvg />,
    vk: <VkSvg />,
    youtube: <YoutubeSvg />,
    telegram: <TelegramSvg />,
    max: <MaxSvg />
  }), [])

  const socialTitles: { [key in Social]: string } = {
    facebook: "Facebook",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    vk: "VK",
    youtube: "Youtube",
    telegram: "Telegram",
    max: "MAX"

  }

  const renderContactItem = useCallback((key: keyof Company): React.ReactNode => {
    const field = company[key]

    if (!field) return <></>

    if (Array.isArray(field)) {
      return field.map((item) => (
        <ContactItem>
          {icons[key]}
          <span children={item as string} />
        </ContactItem>
      ))
    }

    return (
      <ContactItem>
        {icons[key]}
        <span children={field} />
      </ContactItem>
    )
  }, [company, icons])

  console.log(company);
  let country = '';
  let city = '';
  let fullAddress = '';
  const lang = i18n.language as "ru" | "en"

  if(lang == "ru"){
    country = company.country.title_ru;
    city = company.city?company.city.title_ru:'';
    fullAddress = company.fullAddressRu?company.fullAddressRu:'';
  }else{
    country = company.country.title_en;
    city =company.city?company.city.title_en:'';
    fullAddress = company.fullAddressEn?company.fullAddressEn:'';
  }

  let address = country?country:'';
  if(fullAddress){
    address = address+', '+fullAddress
  }else{
    address = address+', '+city
  }


  return (
    <ContactsContainer>
      {renderContactItem("phone")}

      {company.country && (
        <ContactItem>
          {icons.country}
          <span style={{lineHeight: '1.2'}} children={address} />
        </ContactItem>
      )}

      {company.email && (
        <ContactItem>
          {icons.email}
          <a href={`mailto:${company.email}`} children={company.email} />
        </ContactItem>
      )}

      {company.site && company.site.map((item) => (
        <ContactItem>
          {icons.site}
          <a href={`https://${item}`} children={item} target="_blank" rel="noreferrer" />
        </ContactItem>
      ))}

      {company.socialNetwork && company.socialNetwork.map(item => (
        <ContactItem>
          {socialIcons[item.type]}
          <a href={item.text} target="_blank" rel="noreferrer" children={socialTitles[item.type]} />
        </ContactItem>
      ))}
    </ContactsContainer>
  )
}
